import { Action } from "@ngrx/store";
import { IContext } from "../../context/models/context"
import { IGalleryItem } from "../../common/models/gallery-item";

export const LOAD = '[Property Picture] Load';
export const LOAD_COMPLETE = '[Property Picture] Load Complete';
export const LOAD_ERROR = '[Property Picture] Load Error';
export const UPLOAD = '[Property Picture] Upload';
export const UPLOAD_COMPLETE = '[Property Picture] Upload Complete';
export const UPLOAD_ERROR = '[Property Picture] Upload Error';
export const DELETE = '[Property Picture] Delete';
export const DELETE_COMPLETE = '[Property Picture] Delete Complete';
export const DELETE_ERROR = '[Property Picture] Delete Error';

export class Upload implements Action {
  readonly type = UPLOAD;
  constructor(public context: IContext, public files: any) { }
}

export class UploadComplete implements Action {
  readonly type = UPLOAD_COMPLETE;
  constructor(public propertyRef: number, public files: Array<File>) { }
}

export class UploadError implements Action {
  readonly type = UPLOAD_ERROR;
  constructor(public payload: any) { }
}

export class Load implements Action {
  readonly type = LOAD;
  constructor(public propertyRef: number) { }
}

export class LoadComplete implements Action {
  readonly type = LOAD_COMPLETE;
  constructor(public payload: IGalleryItem[]) { }
}

export class LoadError implements Action {
  readonly type = LOAD_ERROR;
  constructor(public payload: any) { }
}

export class Delete implements Action {
  readonly type = DELETE;
  constructor(public documentKey: any, public propertyRef: number, public fileName: string) { }
}

export class DeleteComplete implements Action {
  readonly type = DELETE_COMPLETE;
  constructor(public documentKey: any, public propertyRef: number, public fileName: string) { }
}

export class DeleteError implements Action {
  readonly type = DELETE_ERROR;
  constructor(public documentKey: any, public fileName: string, public error: any) { }
}

export type Actions =
  Upload |
  UploadComplete |
  UploadError |
  Load |
  LoadComplete |
  LoadError |
  Delete |
  DeleteComplete |
  DeleteError;
